import api from '../config/axiosConfig';

export const CategoriaService = {
    getCategorias: async (token) => {
        try {
            const response = await api.get('/ajustes/categorias', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.categorias || [];
        } catch (error) {
            console.error('Error en CategoriaService.fetchCategorias:', error);
            throw error;
        }
    },
    guardarCategoria: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await api.put(`/ajustes/categorias/${editingItem.id}`,
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await api.post('/ajustes/categorias', formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en CategoriaService.guardarCategoria:', error);
            throw error;
        }
    },
};
